import _ from 'lodash';

interface ICodingAfterBuckets {
    providerInstitutional?: unknown;
    providerProfessional?: unknown;
    supportInstitutional?: unknown;
    supportProfessional?: unknown;
}

interface ICodingSignatureInput {
    status?: unknown;
    after?: ICodingAfterBuckets;
}

export function getCodingOutcomeSignature(coding: ICodingSignatureInput): string {
    return stableSerializeValue({
        status: coding.status || null,
        after: getPrimaryCodingAfter(coding.after),
    });
}

function getPrimaryCodingAfter(codingAfter?: ICodingAfterBuckets): unknown {
    if (!codingAfter) {
        return null;
    }

    const orderedBuckets = [
        codingAfter.providerInstitutional,
        codingAfter.providerProfessional,
        codingAfter.supportInstitutional,
        codingAfter.supportProfessional,
    ];

    const primaryBucket = _.find(orderedBuckets, bucket => !_.isNil(bucket) && !_.isEmpty(bucket));
    return primaryBucket || null;
}

function stableSerializeValue(value: unknown): string {
    if (_.isArray(value)) {
        return `[${value.map(item => stableSerializeValue(item)).join(',')}]`;
    }

    if (_.isPlainObject(value)) {
        const normalizedObject = value as Record<string, unknown>;
        const sortedKeys = _.sortBy(Object.keys(normalizedObject));
        const serializedEntries = sortedKeys.map(
            key => `${JSON.stringify(key)}:${stableSerializeValue(normalizedObject[key])}`,
        );
        return `{${serializedEntries.join(',')}}`;
    }

    if (_.isUndefined(value)) {
        return 'null';
    }

    return JSON.stringify(value);
}
